import React, { FC, useEffect, useState, Dispatch, SetStateAction } from 'react';

import { Button, Typography, Grid } from '@mui/material';

import { BackflowJobItem } from '../../model';

import axios from '../../../sharedModules/utils/axios.utils';

import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';

import JobDetailsRow from './JobDetailsRow';

interface JobDetailsSlidedownProps {
  item: BackflowJobItem;
  setSlideOpen: Dispatch<SetStateAction<boolean>>;
}

const JobDetailsSlidedown: FC<JobDetailsSlidedownProps> = (props) => {
  const { item, setSlideOpen } = props;

  const [categories, setCategories] = useState<string[]>([]);
  const [detailsFetched, setDetailsFetched] = useState<boolean>(false);
  const [jobDetails, setJobDetails] = useState<any>({});
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const fetchJobDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get<any>(`/backflows/water_authority_submissions/${item.id}`);
      setJobDetails(response.data.result);
      setCategories(response.data.categories);
    } catch (error) {
      setErrorMessage('Something went wrong fetching the job details');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!detailsFetched) {
      fetchJobDetails();
      setDetailsFetched(true);
    }
  }, []);

  return (
    <LoadingWrapper isLoading={loading}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ErrorMessage message={errorMessage} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">Click a field to copy the value to your clipboard.</Typography>
        </Grid>
        {categories?.map((category) => {
          const entries = Object.entries(jobDetails || {}).filter(([_, v]: [string, any]) => v.category === category);

          if (entries.length === 0) return null;

          return (
            <Grid item xs={12} md={6} key={category}>
              <Typography variant="h6" color="primary" fontWeight={600} gutterBottom>
                {category}
              </Typography>

              <Grid container spacing={1}>
                {entries.map(([key, item]: [string, any]) => (
                  <Grid item xs={item.detail_width} key={key}>
                    <JobDetailsRow key={key} label={item.label} value={item.value} fieldKey={key} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          );
        })}
        <Grid item xs={6} md={3}>
          <Button variant="contained" color="primary" onClick={() => setSlideOpen(false)}>
            Close
          </Button>
        </Grid>
      </Grid>
    </LoadingWrapper>
  );
};

export default JobDetailsSlidedown;
